import React from "react";
import { Card, Form, Input, Button, Avatar, message } from "antd";

import { api_URL } from "../Services/Constantes";
import { MesServices } from "../Services/MesServices";

const Profil = () => {
  const [form] = Form.useForm();
  const mesServices = new MesServices();

  // Récupération du numcont depuis le localStorage
  const numcont = localStorage.getItem("numcont");
  const matipm = localStorage.getItem("matipm");
  const prenom = localStorage.getItem("prenom");
  const nom = localStorage.getItem("nom");
  const portable = localStorage.getItem("portable");
    const photoUrl = `${api_URL}/images/photos/${matipm}.jpg`;

  const onFinish = async (values) => {
    const payload = {
      numcont:numcont,
      pwd_portail: values.newPassword,
    };

    try {
      const response = await mesServices.updateMdp(payload); // Appel API
      message.success("Mot de passe mis à jour avec succès !");
      form.resetFields(); // Réinitialisation du formulaire
    } catch (error) {
      message.error("Erreur lors de la mise à jour du mot de passe.");
      console.error(error);
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
      <Card
        style={{
          width: 400,
          textAlign: "center",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
        }}
      >
        <Avatar
          size={100}
          src={`${api_URL}Participant/getPhoto/${numcont}`} // Remplacez par l'URL de la photo utilisateur
          style={{ marginBottom: "20px" }}
        />
        <h2 style={{ fontWeight: "bold", marginBottom: "5px" }}>{prenom} {nom}</h2>
        <p style={{ color: "#888", marginBottom: "30px" }}>{numcont || "Utilisateur inconnu"} / {portable}</p>

        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          style={{ textAlign: "left" }}
        >
          <Form.Item
            label="Nouveau Mot de Passe"
            name="newPassword"
            rules={[
              { required: true, message: "Veuillez entrer un nouveau mot de passe" },
            ]}
          >
            <Input.Password placeholder="Nouveau mot de passe" />
          </Form.Item>

          <Form.Item
            label="Confirmer Mot de Passe"
            name="confirmPassword"
            dependencies={['newPassword']}
            rules={[
              { required: true, message: "Veuillez confirmer le mot de passe" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(
                    new Error("Les mots de passe ne correspondent pas")
                  );
                },
              }),
            ]}
          >
            <Input.Password placeholder="Confirmer mot de passe" />
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              style={{
                width: "100%",
              //  backgroundColor: "#4a90e2",
                border: "none",
                height: "40px",
                fontWeight: "bold",
              }}
            >
              Enregistrer
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Profil;
